export const SET_CLIENTS = "SET_CLIENTS";
export const SET_DETAIL_CLIENT = "SET_DETAIL_CLIENT";
export const SET_DIALOG_ACTIVE = "SET_DIALOG_ACTIVE";